import { useState } from "react";
import { IoDocumentOutline } from "react-icons/io5";

const Account = () => {
  const [payments, setPayments] = useState([]);
  const [amount, setAmount] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [document, setDocument] = useState(null);

  const handleAdd = () => {
    if (amount && paymentType) {
      const newPayment = {
        amount: Number(amount),
        paymentType,
        date: new Date().toLocaleDateString(),
        document,
      };
      setPayments([...payments, newPayment]);
      setAmount("");
      setPaymentType("");
      setDocument(null);
    }
  };

  return (
    <div className="flex flex-col items-center">
        <div className=" font-bold text-red-500  text-lg mt-5">Account</div>
      <div className="shadow-lg rounded-md p-4 border border-gray-300 mt-5  w-[1000px]">
        <div className="flex gap-3 mt-3 ">
          <label className="font-bold text-lg  ">Franchise Name:</label>
          <span>Chitra</span>
        </div>
        <div className="flex gap-3 mt-3 ">
          <label className="font-bold text-lg  ">Location:</label>
          <span>Vellore</span>
        </div>
        <div className="flex gap-3 mt-3 ">
          <label className="font-bold text-lg  ">Address:</label>
          <span>Anna Nagar</span>
        </div>
      </div>

      <div className="flex mt-5 gap-5">
        <div className="shadow-lg  p-4 w-[480px]
        ">
          <div className="flex justify-between">
            <span className="  font-bold text-red-600
            ">Total Amount:</span>
            <button className="bg-green-500 text-white px-3 py-1 rounded-full font-semibold">Status</button>
          </div>

          <div className="mt-4">
            <h4 className=" font-bold text-red-600 ">Payment History:</h4>
          
           
            {payments.length > 0 ? (
              <table className="w-full border mt-5">
                <thead className="bg-red-600 text-white whitespace-nowrap">
                  <tr>
                    <th className="p-2 text-sm">Date</th>
                    <th className="p-2 text-sm">Amount</th>
                    <th className="p-2 text-sm">Payment</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((payment, index) => (
                    <tr key={index} className="text-center border-t">
                      <td className="p-2 text-sm">{payment.date}</td>
                      <td className="p-2 text-sm">₹{payment.amount}</td>
                      <td className="p-2 text-sm">{payment.paymentType}</td>
                      <td className="p-2 text-sm">
                        {payment.document && <IoDocumentOutline />}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No payments added yet.</p>
            )}
          </div>
        </div>

        <div className="shadow-lg rounded-md p-4  w-[480px]
        ">
          <button className="w-full  py-2 rounded-md mb-4 font-bold text-red-600
          ">Add Payment</button>
          
          <div className="mb-4">
            <label className="block font-medium">Amount:</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
              className="w-full px-2 py-2 border rounded-md text-sm outline-none"
            />
          </div>

          <div className="mb-4">
            <label className="block font-medium">Payment Mode:</label>
            <select
              value={paymentType}
              onChange={(e) => setPaymentType(e.target.value)}
              className="w-full px-2 py-2 border rounded-md text-sm"
            >
              <option value="">Select Payment Mode</option>
              <option value="GPay">GPay</option>
              <option value=" PhonePay"> PhonePay </option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block font-medium">Document:</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setDocument(e.target.files[0])}
              className="w-full px-2 py-2 border rounded-md text-sm"
            />
          </div>

          <button
            onClick={handleAdd}
            className="w-full bg-red-500 text-white font-bold p-2 rounded-md"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default Account;